// extracted by mini-css-extract-plugin
module.exports = {"header":"ClassicHeader_header__3aIf5","salonHeading":"ClassicHeader_salonHeading__OiFnm"};